import { render, staticRenderFns } from "./Migrating.vue?vue&type=template&id=afda6358&scoped=true&"
import script from "./Migrating.vue?vue&type=script&lang=js&"
export * from "./Migrating.vue?vue&type=script&lang=js&"
import style0 from "./Migrating.vue?vue&type=style&index=0&id=afda6358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afda6358",
  null
  
)

export default component.exports